import React, { useCallback, useContext, useMemo, useState } from 'react';
import ConfirmationModal from '../modals/ConfirmationModal';
import CheckinFinishModal from '../modals/CheckinFinishModal';
import ResetPasswordModal from '../modals/ResetPasswordModal';
import AddBookingModal from '../modals/AddBookingModal';
import TranslationsModal from '../modals/TranslationsModal';
import PaymentModal from '../modals/PaymentModal';
import EmailLogsModal from '../modals/EmailLogsModal';
import ImageTranslationsModal from '../modals/ImageTranslationsModal';
import CancellationConfirmationModal from '../modals/CancellationConfirmationModal';
import RefundConfirmationModal from '../modals/RefundConfirmationModal';
import RichTextTranslationsModal from '../modals/RichTextTranslationsModal';
import ManualRefundModal from '../modals/ManualRefundModal';
import SeatingImportModal from '../modals/SeatingImportModal';
import SeatingCloneModal from '../modals/SeatingCloneModal';
import EnableTwoFactorModal from '../modals/EnableTwoFactorModal';
import TwoFactorLoginModal from '../modals/TwoFactorLoginModal';
import GenerateInvoiceModal from '../modals/GenerateInvoiceModal';
import TransactionNoteEditModal from '../modals/TransactionNoteEditModal';
import TransactionProcessingFeeEditModal from '../modals/TransactionProcessingFeeEditModal';
import CustomRollbackTimeModal from '../modals/CustomRollbackTimeModal';
import ReSourceBookingModal from '../modals/ReSourceBookingModal';
import TransactionPaymentTypeModal from '../modals/TransactionPaymentTypeModal';
import CancelTimeslotModal from '../modals/CancelTimeslotModal';

const ModalContext = React.createContext();

export const MODAL_TYPE = {
    CONFIRMATION: 'CONFIRMATION',
    CHECKIN_FINISH: 'CHECKIN_FINISH',
    RESET_PASSWORD: 'RESET_PASSWORD',
    ADD_BOOKING: 'ADD_BOOKING',
    TRANSLATIONS: 'TRANSLATIONS',
    PAYMENT: 'PAYMENT',
    EMAIL_LOGS: 'EMAIL_LOGS',
    IMAGE_TRANSLATIONS: 'IMAGE_TRANSLATIONS',
    RICHTEXT_TRANSLATIONS: 'RICHTEXT_TRANSLATIONS',
    CANCELLATION_CONFIRMATION: 'CANCELLATION_CONFIRMATION',
    REFUND_CONFIRMATION: 'REFUND_CONFIRMATION',
    MANUAL_REFUND: 'MANUAL_REFUND',
    SEATING_IMPORT: 'SEATING_IMPORT',
    SEATING_CLONE: 'SEATING_CLONE',
    ENABLE_TWO_FACTOR: 'ENABLE_TWO_FACTOR',
    LOGIN_TWO_FACTOR: 'LOGIN_TWO_FACTOR',
    GENERATE_INVOICE: 'GENERATE_INVOICE',
    TRANSACTION_NOTE_EDIT: 'TRANSACTION_NOTE_EDIT',
    TRANSACTION_PROCESSING_FEE_EDIT: 'TRANSACTION_PROCESSING_FEE_EDIT',
    CUSTOM_ROLLBACK_TIME: 'CUSTOM_ROLLBACK_TIME',
    RE_SOURCE_BOOKING: 'RE_SOURCE_BOOKING',
    TRANSACTION_PAYMENT_TYPE: 'TRANSACTION_PAYMENT_TYPE',
    CANCEL_TIMESLOT: 'CANCEL_TIMESLOT',
    NONE: false,
};

export function Modals() {
    return (
        <ModalContext.Consumer>
            {(context) => {
                const allProps = {
                    ...context.props,
                    currentlyShowingModal: context.currentlyShowingModal,
                    showModal: context.showModal,
                    MODAL_TYPE,
                };
                return (
                    <div>
                        {context.currentlyShowingModal === MODAL_TYPE.CONFIRMATION && (
                            <ConfirmationModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CHECKIN_FINISH && (
                            <CheckinFinishModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.RESET_PASSWORD && (
                            <ResetPasswordModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.ADD_BOOKING && (
                            <AddBookingModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.TRANSLATIONS && (
                            <TranslationsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.PAYMENT && (
                            <PaymentModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.EMAIL_LOGS && (
                            <EmailLogsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.IMAGE_TRANSLATIONS && (
                            <ImageTranslationsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.RICHTEXT_TRANSLATIONS && (
                            <RichTextTranslationsModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CANCELLATION_CONFIRMATION && (
                            <CancellationConfirmationModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.REFUND_CONFIRMATION && (
                            <RefundConfirmationModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.MANUAL_REFUND && (
                            <ManualRefundModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SEATING_IMPORT && (
                            <SeatingImportModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.SEATING_CLONE && (
                            <SeatingCloneModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.ENABLE_TWO_FACTOR && (
                            <EnableTwoFactorModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.LOGIN_TWO_FACTOR && (
                            <TwoFactorLoginModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.GENERATE_INVOICE && (
                            <GenerateInvoiceModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.TRANSACTION_NOTE_EDIT && (
                            <TransactionNoteEditModal {...allProps} />
                        )}
                        {context.currentlyShowingModal ===
                            MODAL_TYPE.TRANSACTION_PROCESSING_FEE_EDIT && (
                            <TransactionProcessingFeeEditModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CUSTOM_ROLLBACK_TIME && (
                            <CustomRollbackTimeModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.RE_SOURCE_BOOKING && (
                            <ReSourceBookingModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.TRANSACTION_PAYMENT_TYPE && (
                            <TransactionPaymentTypeModal {...allProps} />
                        )}
                        {context.currentlyShowingModal === MODAL_TYPE.CANCEL_TIMESLOT && (
                            <CancelTimeslotModal {...allProps} />
                        )}
                    </div>
                );
            }}
        </ModalContext.Consumer>
    );
}

export function ModalContextProvider({ children }) {
    const [modalState, setModalState] = useState({
        currentlyShowingModal: false,
        props: {},
    });

    const showModal = useCallback(
        (currentlyShowingModal, newprops = {}) => {
            setModalState({
                currentlyShowingModal,
                props: newprops,
            });
        },
        [setModalState],
    );

    return useMemo(
        () => (
            <ModalContext.Provider value={{ ...modalState, showModal }}>
                {children}
                <Modals />
            </ModalContext.Provider>
        ),
        [modalState, showModal, children],
    );
}

ModalContext.displayName = 'ModalContext';

export function useModals() {
    return useContext(ModalContext);
}
